// extracted by mini-css-extract-plugin
module.exports = {"copy-all-icon":"styles_copy-all-icon__3yNB5","hover-pointer":"styles_hover-pointer__20XxV","text-orange":"styles_text-orange__KoFwG"};